import PostReminderHowItWorksView from '@/legacy/components/webComponents/PostReminderHowItWorksView'
import CheckoutShippingHowItWorksView from '@/legacy/components/webComponents/CheckoutShippingHowItWorksView'

const Name = Object.freeze({
	// Name should start with 'web-component-' to fit vite's custom element name
	PostReminderHowItWorksView: 'web-component-post-reminder-how-it-works-view',
	CheckoutShippingHowItWorksView:
		'web-component-checkout-shipping-how-it-works-view',
})

function registeWebcomponent(
	name: string,
	constructor: CustomElementConstructor,
) {
	if (window.customElements.get(name)) return
	window.customElements.define(name, constructor)
}

const createPostReminderHowItWorksView = registeWebcomponent.bind(
	this,
	Name.PostReminderHowItWorksView,
	PostReminderHowItWorksView,
)

const createCheckoutShippingHowItWorksView = registeWebcomponent.bind(
	this,
	Name.CheckoutShippingHowItWorksView,
	CheckoutShippingHowItWorksView,
)

export {
	Name,
	createPostReminderHowItWorksView,
	createCheckoutShippingHowItWorksView,
}
